import dayjs from 'dayjs';
import { Http } from '@/lib/http';

export class ClimateRiskAssessmentIntegrationService extends Http {
  constructor() {
    super();
    this.endPoint = 'integration/climate-risk-assessment';
  }

  /**
   * checks if enabled climate risk assessment endpoints are online
   * @throws HttpError
   */
  async checkStatus() {
    try {
      return this.httpClient().post(`${this.endPoint}`);
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get assessments results
   * @return Promise<any>
   */
  async getAssessmentResults(assessmentInput) {
    return this.httpClient().post(`${this.endPoint}`, assessmentInput);
  }

}
